export default __webpack_public_path__ + "static/media/dermatology.b7733b7a.png";